// eslint-disable-next-line import/prefer-default-export
export var LOGO_COVER_TRANSLATIONS = {
    logoCover: {
        titleLogo: 'Logo de sucursal',
        titleCover: 'Imagen de portada',
        titleExample: 'Así se verán tu logo y portada:',
        fileUpload: {
            buttonText: 'Selecciona un archivo',
            title: 'Arrastra las imagenes aquí ó',
            formats: 'Formatos:',
            maxSize: 'Tamaño máximo',
            remove: 'Eliminar archivo',
        },
        editor: {
            cropText: 'Recortar',
            rotateLeftText: 'Girar a la izquierda',
            editImageText: 'Editar',
            onSaveText: 'Ok',
            rotateRightText: 'Girar a la derecha',
            zoomInText: 'Acercar',
            zoomOutText: 'Alejar',
        },
        errors: {
            errorLoad: 'Hubo un error al cargar',
            invalidType: 'El formato del archivo no es el permitido',
            tooLarge: 'El tamaño del archivo es mayor al permitido',
            tooSmall: 'La resolución de la imagen es menor a la permitida',
            tooManyFiles: 'Se ha excedido el numero de archivos permitidos',
            genericError: 'Intentar nuevamente',
        },
        modal: {
            ok: 'Entendido',
        },
    },
};
